import { focus, pxToRem } from '../../helpers'
import { StyleFn } from '..'

export const Stepper: StyleFn = (theme) => {
  const { color, font, size } = theme
  const { focusWithPseudo } = focus(theme)

  return {
    root: {
      display: 'flex',
      margin: 0,
      padding: 0,
      '& > *': {
        flex: 1,
        display: 'flex',
      },
    },
    _vertical: {
      flexDirection: 'column',
      '& $step': {
        alignItems: 'flex-start',
        position: 'relative',
        minHeight: size.spacing[56],
        '&:last-child': {
          minHeight: 'unset',
          flex: 'unset',
        },
        '&:after': {
          content: "''",
          position: 'absolute',
          top: size.spacing[32],
          left: `calc(${size.spacing[16]} - 1px)`,
          bottom: 0,
          width: 2,
          zIndex: 0,
          backgroundColor: color.palette.warmgrey[20],
        },
        '&$step_complete:after': {
          backgroundColor: color.brand.normal,
        },
        '&:last-child:after': { display: 'none' },
      },
      '& $stepHeader': {
        width: 'auto',
        flexDirection: 'row',
        '&:after': { display: 'none' },
        // add padding to focus state in vertical mode
        '&:focus-visible:before': {
          bottom: `calc(-${size.spacing[8]})`,
          top: `calc(-${size.spacing[8]})`,
          left: `calc(-${size.spacing[8]})`,
          right: `calc(-${size.spacing[8]})`,
        },
      },
      '& $stepNumber': {
        marginBottom: 0,
        marginRight: size.spacing[8],
      },
      '& $stepContent': {
        marginLeft: size.spacing[40],
      },
    },
    step: {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      listStyle: 'none',
      '&:last-child  $stepHeader:after': { display: 'none' },
    },
    step_complete: {
      '& > $stepHeader': {
        color: color.background.interactive.ghost.contrastText,
        '&:after': {
          backgroundColor: color.brand.normal,
        },
      },
      '& $stepNumber': {
        color: color.brand.normal,
        border: `1px solid ${color.brand.normal}`,
        backgroundColor: color.palette.white,
      },
    },
    step_current: {
      '& > $stepHeader': {
        color: color.background.interactive.ghost.contrastText,
        fontWeight: font.weight.bold,
      },
      '& $stepNumber': {
        backgroundColor: color.brand.normal,
        color: color.palette.white,
      },
    },
    stepHeader: {
      extend: [focusWithPseudo({ pseudo: 'before' })],
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      width: '100%',
      position: 'relative',
      fontSize: font.size.small,
      fontWeight: font.weight.regular,
      whiteSpace: 'nowrap',
      color: color.palette.coolgrey[60],
      borderRadius: 3,
      cursor: 'pointer',
      // horizontal connector
      '&:after': {
        pointerEvents: 'none',
        content: "''",
        position: 'absolute',
        width: '100%',
        height: 2,
        top: size.spacing[16],
        right: '-50%',
        backgroundColor: color.palette.warmgrey[20],
        zIndex: 0,
      },
      "&[aria-disabled='true']": {
        pointerEvents: 'none',
      },
    },
    stepNumber: {
      width: size.spacing[32],
      height: size.spacing[32],
      lineHeight: size.spacing[32],
      borderRadius: size.spacing[32],
      backgroundColor: color.palette.warmgrey[20],
      fontWeight: font.weight.medium,
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1,
      marginBottom: size.spacing[8],
      // icons
      '& i, & svg': {
        fontSize: size.spacing[16],
        width: size.spacing[16],
        height: size.spacing[16],
        display: 'inline-flex',
      },
    },
    stepContent: {
      color: color.getModalValues(color.text.primary),
      padding: `${size.spacing[8]} 0`,
    },
    stepSubsteps: {
      padding: `${size.spacing[16]} 0`,
      paddingLeft: size.spacing[40],
      fontSize: font.size.small,
      fontWeight: font.weight.regular,
      color: color.palette.coolgrey[60],
      position: 'relative',
      '& $step': {
        minHeight: 'unset',
        padding: size.spacing[8],
        lineHeight: size.spacing[24],
        '&:after': {
          top: 'calc(-50%)',
          bottom: '50%',
          left: `calc(-${size.spacing[24]} - 1px)`,
          zIndex: 2,
        },
        '&:last-child:after': { display: 'unset' },
        '&:before': {
          content: "''",
          width: size.spacing[4],
          height: size.spacing[4],
          borderRadius: '50%',
          backgroundColor: color.palette.coolgrey[60],
          position: 'absolute',
          zIndex: 3,
          top: `calc(50% - ${size.spacing[2]})`,
          left: pxToRem(-26),
        },
        '&$step_complete:before': {
          backgroundColor: color.brand.normal,
        },
        '&$step_current:after': {
          backgroundColor: color.brand.normal,
        },
        '&$step_current:before': {
          backgroundColor: color.brand.normal,
          width: size.spacing[8],
          height: size.spacing[8],
          borderRadius: '50%',
          top: `calc(50% - ${size.spacing[4]})`,
          left: pxToRem(-28),
        },
      },
    },
  }
}
